import React from "react";
import { purchaseSteps } from "./purchaseFeatureConstant";
import MarqueeCardScroller from "../../../Utility/MarqueeCardScroller";

const PurchaseCardScroller: React.FC = () => {
  return <MarqueeCardScroller items={purchaseSteps} />;
};

export default PurchaseCardScroller;
